import { getFunctions, httpsCallable } from 'firebase/functions';

export interface GbrainSkillRef {
  name: string;
  description: string | null;
  path: string;
  folder: string;
}

export interface GbrainSkillsByCapability {
  capabilityId: string;
  skills: GbrainSkillRef[];
}

export interface ListGbrainSkillsResult {
  success: boolean;
  repo: string;
  prefix: string;
  count: number;
  skills: Array<GbrainSkillRef & { capabilityId: string | null }>;
  byCapability: GbrainSkillsByCapability[];
}

/** Fetch CompanyBrain SKILL.md packages from GitHub (via Cloud Function). */
export async function listGbrainSkills(force = false): Promise<ListGbrainSkillsResult> {
  const fn = httpsCallable<{ force?: boolean }, ListGbrainSkillsResult>(
    getFunctions(undefined, 'us-central1'),
    'listGbrainSkills',
  );
  const res = await fn(force ? { force: true } : {});
  return res.data;
}

/** Map capability id → skill packages. */
export function skillsMapFromResult(
  result: ListGbrainSkillsResult | null,
): Map<string, GbrainSkillRef[]> {
  const map = new Map<string, GbrainSkillRef[]>();
  if (!result) return map;
  for (const row of result.byCapability) {
    map.set(row.capabilityId, row.skills);
  }
  return map;
}
